const E504 = () => (
  <div className="error-container error-504">
    <h1>504</h1>
    <p className="title">Gateway Timeout</p>
    <p>The server didn’t receive a timely response from an upstream server.</p>
  </div>
);

export default E504;
